// Extracted from legacy src/components/templates.js

// Default theme to ensure consistency
export const DEFAULT_THEME = {
  id: 'modernBliss',
  colors: {
    primary: '#4E7C7F',
    secondary: '#F7F7F6',
    accent: '#9CC5BD',
    background: '#FFFFFF',
    text: '#1C1C1A'
  },
  fonts: {
    heading: "'Poppins', sans-serif",
    body: "'Inter', sans-serif"
  },
  spacing: {
    unit: '8px',
    scale: [0, 8, 16, 24, 32, 40, 48, 56, 64]
  },
  borderRadius: {
    small: '8px',
    medium: '16px',
    large: '24px'
  },
  shadows: {
    small: '0 4px 8px rgba(0,0,0,0.1)',
    medium: '0 8px 16px rgba(0,0,0,0.15)',
    large: '0 16px 32px rgba(0,0,0,0.2)'
  }
};

// Theme Definitions
export const THEMES = {
  coastalDreams: {
    id: 'coastalDreams',
    colors: {
      primary: '#4B5563',     // Graphite
secondary: '#F3F4F6',   // Light Gray
accent: '#059669',      // Emerald Green
background: '#FFFFFF',  // Pure White
text: '#1F2937'  
    },
    fonts: {
      heading: "'Montserrat', sans-serif",
      body: "'Inter', sans-serif"
    },
    spacing: {
      unit: '8px',
      scale: [0, 8, 16, 24, 32, 40, 48, 56, 64]
    },
    borderRadius: {
      small: '8px',
      medium: '16px',
      large: '24px'
    },
    shadows: {
      small: '0 4px 8px rgba(8, 145, 178, 0.1)',
      medium: '0 8px 16px rgba(8, 145, 178, 0.15)',
      large: '0 16px 32px rgba(8, 145, 178, 0.2)'
    }
  },
  tropicalParadise: {
    id: 'tropicalParadise',
    colors: {
     primary: '#06B6D4', // Turquoise/Cyan
      secondary: '#ECFEFF', // Light Turquoise
      accent: '#DC2626', // Hibiscus Red
      background: '#FFFFFF', // Pure White
      text: '#1F2937',
    },
    fonts: {
      heading: "'Playfair Display', serif",
      body: "'Inter', sans-serif"
    },
    spacing: {
      unit: '8px',
      scale: [0, 8, 16, 24, 32, 40, 48, 56, 64]
    },
    borderRadius: {
      small: '6px',
      medium: '12px',
      large: '20px'
    },
    shadows: {
      small: '0 4px 6px rgba(16, 185, 129, 0.1)',
      medium: '0 8px 15px rgba(16, 185, 129, 0.15)',
      large: '0 15px 30px rgba(16, 185, 129, 0.2)'
    }
  },
  sunsetBeach: {
    id: 'sunsetBeach',
    colors: {
    primary: '#DD2E18',     // Reddish Orange (trend #26)
    secondary: '#FFF5EE',   // Seashell White
    accent: '#FFAB00',      // Light Orange (trend #26)
    background: '#FFF5EE',  // Seashell White
    text: '#3A3042'         // Dark Plum
    },
    fonts: {
      heading: "'Lora', serif",
      body: "'Inter', sans-serif"
    },
    spacing: {
      unit: '10px',
      scale: [0, 10, 20, 30, 40, 50, 60, 70, 80]
    },
    borderRadius: {
      small: '10px',
      medium: '20px',
      large: '30px'
    },
    shadows: {
      small: '0 3px 5px rgba(219, 39, 119, 0.1)',
      medium: '0 6px 10px rgba(219, 39, 119, 0.15)',
      large: '0 12px 24px rgba(219, 39, 119, 0.2)'
    }
  },
  'garden-bliss': {
    id: 'garden-bliss',
    colors: {
      primary: '#009B4D', // Rich Green (trend #10)
      secondary: '#FAF5E9', // Ivory (trend #10)
      accent: '#FFCC00', // Yellow (trend #10)
      background: '#FFFFFF', // Clean White
      text: '#1C1C1A' // Dark Charcoal
    },
    fonts: {
      heading: "'Merriweather', serif",
      body: "'Open Sans', sans-serif"
    },
    spacing: {
      unit: '8px',
      scale: [0, 8, 16, 24, 32, 40, 48, 56, 64]
    },
    borderRadius: {
      small: '2px',
      medium: '6px',
      large: '12px'
    },
    shadows: {
      small: '0 2px 4px rgba(0, 155, 77, 0.1)',
      medium: '0 4px 8px rgba(0, 155, 77, 0.15)',
      large: '0 8px 16px rgba(0, 155, 77, 0.2)'
    }
  },
  simpleElegance: {
    id: 'simpleElegance',
    colors: {
      primary: '#6366F1', // Modern Indigo
      secondary: '#EEF2FF', // Indigo Light
      accent: '#EC4899', // Pink
      background: '#FFFFFF', // Pure White
      text: '#1F2937' // Gray Dark
    },
    fonts: {
      heading: "'Cormorant Garamond', serif",
      body: "'Inter', sans-serif"
    },
    spacing: {
      unit: '8px',
      scale: [0, 8, 16, 24, 32, 40, 48, 56, 64]
    },
    borderRadius: {
      small: '4px',
      medium: '8px',
      large: '16px'
    },
    shadows: {
      small: '0 2px 4px rgba(99, 102, 241, 0.1)',
      medium: '0 4px 8px rgba(99, 102, 241, 0.15)',
      large: '0 8px 16px rgba(99, 102, 241, 0.2)'
    }
  },
  modernMinimal: {
    id: 'modernMinimal',
    colors: {
      primary: '#18181B',
      secondary: '#F1F5F9',  // Cool light gray
      accent: '#0EA5E9',     // Sky blue
      background: '#FFFFFF',
      text: '#1E293B'
    },
    fonts: {
      heading: "'Space Grotesk', sans-serif",
      body: "'Inter', sans-serif"
    },
    spacing: {
      unit: '8px',
      scale: [0, 8, 16, 24, 32, 40, 48, 56, 64]
    },
    borderRadius: {
      small: '2px',
      medium: '4px',
      large: '8px'
    },
    shadows: {
      small: '0 1px 2px rgba(0, 0, 0, 0.05)',
      medium: '0 2px 4px rgba(0, 0, 0, 0.1)',
      large: '0 4px 8px rgba(0, 0, 0, 0.15)'
    }
  },
  romanticVintage: {
    id: 'romanticVintage',
    colors: {
  primary: '#2D3F4A', // Тъмно синьо (Dark navy blue) - от класическия автомобил
secondary: '#F6F3EF', // Сватбено бяло (Wedding white) - от роклята на булката
accent: '#566246', // Горска зеленина (Forest green) - от заобикалящите дървета
background: '#F0EFEB', // Светла мъгла (Light mist) - от светлината, обливаща сцената
text: '#3C3532' // Тъмен орех (Dark walnut) - от кожения куфар и детайлите/ Тъмен патладжан (Deep aubergine)
    },
    fonts: {
      heading: "'Cormorant', serif",
      body: "'Lora', serif"
    },
    spacing: {
      unit: '8px',
      scale: [0, 8, 16, 24, 32, 40, 48, 56, 64]
    },
    borderRadius: {
      small: '0px',
      medium: '0px',
      large: '0px'
    },
    shadows: {
      small: '0 2px 4px rgba(190, 24, 93, 0.1)',
      medium: '0 4px 8px rgba(190, 24, 93, 0.15)',
      large: '0 8px 16px rgba(190, 24, 93, 0.2)'
    }
  },
  boldContemporary: {
    id: 'boldContemporary',
    colors: {
      primary: '#1F2937',     // Charcoal (softer than pure black)
secondary: '#F9FAFB',   // Off White
accent: '#DC2626',      // Deep Red
background: '#FFFFFF',  // Pure White
text: '#111827'         // Dark Gray
    },
    fonts: {
      heading: "'Syne', sans-serif",
      body: "'Inter', sans-serif"
    },
    spacing: {
      unit: '8px',
      scale: [0, 8, 16, 24, 32, 40, 48, 56, 64]
    },
    borderRadius: {
      small: '0px',
      medium: '0px',
      large: '0px'
    },
    shadows: {
      small: '0 2px 4px rgba(0, 0, 0, 0.1)',
      medium: '0 4px 8px rgba(0, 0, 0, 0.15)',
      large: '0 8px 16px rgba(0, 0, 0, 0.2)'
    }
  },
  playfulModern: {
    id: 'playfulModern',
    colors: {
     primary: '#06B6D4',     // Cyan
secondary: '#ECFEFF',   // Cyan Light
accent: '#10B981',      // Green (keeping your current accent!)
background: '#FFFFFF',  // Pure White
text: '#1F2937'         // Gray Dark
    },
    fonts: {
      heading: "'Outfit', sans-serif",
      body: "'Inter', sans-serif"
    },
    spacing: {
      unit: '8px',
      scale: [0, 8, 16, 24, 32, 40, 48, 56, 64]
    },
    borderRadius: {
      small: '16px',
      medium: '24px',
      large: '32px'
    },
    shadows: {
      small: '0 4px 8px rgba(124, 58, 237, 0.1)',
      medium: '0 8px 16px rgba(124, 58, 237, 0.15)',
      large: '0 16px 32px rgba(124, 58, 237, 0.2)'
    }
  },
  cleanLines: {
    id: 'cleanLines',
    colors: {
      primary: '#374151', // Gray
      secondary: '#F9FAFB', // Off White
      accent: '#6B7280', // Medium Gray
      background: '#FFFFFF', // Pure White
      text: '#1F2937' // Dark Gray
    },
    fonts: {
      heading: "'Inter', sans-serif",
      body: "'Inter', sans-serif"
    },
    spacing: {
      unit: '8px',
      scale: [0, 8, 16, 24, 32, 40, 48, 56, 64]
    },
    borderRadius: {
      small: '2px',
      medium: '4px',
      large: '8px'
    },
    shadows: {
      small: '0 1px 2px rgba(0, 0, 0, 0.05)',
      medium: '0 2px 4px rgba(0, 0, 0, 0.1)',
      large: '0 4px 8px rgba(0, 0, 0, 0.15)'
    }
  },
  festiveJoy: {
    id: 'festiveJoy',
    colors: {
      primary: '#D8125B',   // Fuchsia (trend #3)
      secondary: '#F8F9FA', // Almost White
      accent: '#2C2E39',    // Dark Grey (trend #3)
      background: '#FFFFFF', // Pure White
      text: '#212121'       // Charcoal
    },
    fonts: {
      heading: "'Playfair Display', serif",
      body: "'Inter', sans-serif"
    },
    spacing: {
      unit: '8px',
      scale: [0, 8, 16, 24, 32, 40, 48, 56, 64]
    },
    borderRadius: {
      small: '16px',
      medium: '24px',
      large: '32px'
    },
    shadows: {
      small: '0 4px 12px rgba(220, 38, 38, 0.15)',
      medium: '0 8px 24px rgba(220, 38, 38, 0.2)',
      large: '0 16px 48px rgba(220, 38, 38, 0.25)'
    }
  },
  vibrantCelebration: {
    id: 'vibrantCelebration',
    colors: {
      primary: '#0A1828',   // Classic Blue (trend #21)
      secondary: '#178582', // Turquoise (trend #21)
      accent: '#BFA181',    // Gold (trend #21)
      background: '#F8FAFC', // Cool White
      text: '#1E293B'       // Slate Gray
    },
    fonts: {
      heading: "'Poppins', sans-serif",
      body: "'Inter', sans-serif"
    },
    spacing: {
      unit: '8px',
      scale: [0, 8, 16, 24, 32, 40, 48, 56, 64]
    },
    borderRadius: {
      small: '12px',
      medium: '20px',
      large: '32px'
    },
    shadows: {
      small: '0 4px 12px rgba(255, 51, 102, 0.15)',
      medium: '0 8px 24px rgba(255, 51, 102, 0.2)',
      large: '0 16px 48px rgba(255, 51, 102, 0.25)'
    }
  }
};
